import type { VoidFunctionComponent } from 'react';

import { FormLabel, FormLabelVariant } from '../../generic/Forms';
import Select from '../../generic/Select/Select';
import type { SelectOption } from '../../../types';

import styles from './SettingsOrganizationProject.module.less';

type Props = {
  id: string;
  label: string;
  options: Array<SelectOption<string | number | null>>;
  value: SelectOption<string | number | null>;
  onChange: (option: SelectOption<string | number | null> | null) => void;
  isDisabled?: boolean;
};

/**
 * SettingsPageDropdown is a generic dropdown component,
 * with a few sane defaults for use in the settings pages.
 */
const SettingsPageDropdown: VoidFunctionComponent<Props> = ({
  id,
  label,
  options,
  value,
  onChange,
  isDisabled,
}) => (
  <div className={styles.dropdown}>
    <FormLabel label={label} variant={FormLabelVariant.Filter}>
      <Select
        id={id}
        onChange={onChange}
        options={options}
        value={value}
        isDisabled={isDisabled}
      />
    </FormLabel>
  </div>
);

export default SettingsPageDropdown;
